<script>
  import ProductListItem from '@/components/ProductListItem.vue';
  import { Carousel, Slide, Navigation } from 'vue3-carousel';
  import { getProductMetafieldFromFS, getProductCollectionMetafieldFromFS, whenFastSimonReady, handleViewportSize, logFastSimonError } from '@/lib/vue-helpers.js';
  import { emitter } from '@/main.js';

  export default {
    name: 'CollectionSlider',
    components: {
      ProductListItem,
      Carousel,
      Navigation,
      Slide
    },
    data() {
      return {
        collectionId: '',
        collectionHandle: '',
        pids: '',
        recPid: '',
        itemsToScroll: 2,
        itemsToShow: 4,
        productImageName: '',
        productsOnDisplay: [],
        maxProducts: 0,
        arrow_left_image: '',
        arrow_left_image_alt: '',
        arrow_left_image_width: '',
        arrow_left_image_height: '',
        arrow_left_image_disabled: '',
        arrow_left_image_disabled_alt: '',
        arrow_left_image_disabled_width: '',
        arrow_left_image_disabled_height: '',
        arrow_custom_on: false,
        arrow_custom_off: false,
        slideNextBtn: '',
        slidePrevBtn: '',
        gridDesktop: 4,
        gridMobile: 1.2,
        gridTablet: 3,
        titleHeading: '',
        hideHeader: false,
        useFsWidgetRecs: false,
        useFsSmartCollection: false,
        useFsRecs: false,
        widgetId: '',
        useFsProductData: '',
        isTab: false,
        isDefaultTab: false,
        hasLoadedProducts: false,
        currentSlide: 0,
        loadedCollections: new Map(),
        productCategoryMetafieldOneAttr: '',
        productCategoryMetafieldTwoAttr: '',
        productCategoryMetafieldOneCollectionAttr: '',
        productCategoryMetafieldTwoCollectionAttr: '',
        productReminderMetafieldEmbedAttr: '',
        setReminderLinkText: '',
        loadedSlides: new Set(),
        showCrosssellPercentage: 'false',
        carouselHeightRefreshTimeout: null
      };
    },
    mounted() {
      this.handleViewportSize = handleViewportSize(this);
      this.productCategoryMetafieldOneAttr = window.siteGlobals.product_cat_metafield_one || '';
      this.productCategoryMetafieldTwoAttr = window.siteGlobals.product_cat_metafield_two || '';
      this.productCategoryMetafieldOneCollectionAttr = window.siteGlobals.product_cat_metafield_one_collection || '';
      this.productCategoryMetafieldTwoCollectionAttr = window.siteGlobals.product_cat_metafield_two_collection || '';
      this.productReminderMetafieldEmbedAttr = window.siteGlobals.set_reminder_metafield;

      this.setReminderLinkText = window.siteGlobals.set_reminder_link_text;

      this.collectionId = this.$el.parentElement.getAttribute('data-collection-id');
      this.collectionHandle = this.$el.parentElement.getAttribute('data-collection-handle');
      this.maxProducts = this.$el.parentElement.getAttribute('data-product-limit');

      this.pids = JSON.parse(this.$el.parentElement.getAttribute('data-pids'));
      this.titleHeading = this.$el.parentElement.getAttribute('data-title');
      this.hideHeader = this.$el.parentElement.getAttribute('data-hide-header');
      // prettier-ignore
      this.productImageName = this.$el.parentElement.getAttribute('data-product-swatch-name');
      this.gridDesktop = this.$el.parentElement.getAttribute('data-grid-desktop');
      this.gridMobile = this.$el.parentElement.getAttribute('data-grid-mobile');
      this.gridTablet = this.$el.parentElement.getAttribute('data-grid-tablet');
      this.widgetId = this.$el.parentElement.getAttribute('data-fs-widget-id');
      // prettier-ignore
      this.useFsWidgetRecs = this.$el.parentElement.getAttribute('data-use-fs-widget-recs') === 'true' || this.$el.parentElement.getAttribute('data-use-fs-widget-recs') === true;
      // prettier-ignore
      this.useFsSmartCollection = this.$el.parentElement.getAttribute('data-use-fs-smart-collection') === 'true' || this.$el.parentElement.getAttribute('data-use-fs-smart-collection') === true;
      // prettier-ignore
      this.useFsRecs = this.$el.parentElement.getAttribute('data-use-fs-recs') === 'true' || this.$el.parentElement.getAttribute('data-use-fs-recs') === true;
      // prettier-ignore
      const useFsProductDataAttr = this.$el.parentElement.getAttribute('data-use-fs-product-data') || this.$el.parentElement.getAttribute('data-use_fs_product_data');
      // prettier-ignore
      this.useFsProductData = useFsProductDataAttr === 'true' ? 'true' : '';
      // prettier-ignore
      this.arrow_custom_on = this.$el.parentElement.getAttribute('data-arrow-custom-on') === 'true';

      this.slidePrevBtn = this.$el.parentElement.querySelector('.carousel__prev');
      this.slideNextBtn = this.$el.parentElement.querySelector('.carousel__next');
      // prettier-ignore
      this.slidePrevBtnCustom = this.$el.parentElement.querySelector('.custom__arrow--prev');
      // prettier-ignore
      this.slideNextBtnCustom = this.$el.parentElement.querySelector('.custom__arrow--next');
      this.currentSlide = 0;
      this.slidesCount = 0;
      this.slidePrevBtnCustom.setAttribute('disabled', 'disabled');

      this.arrow_left_image = this.$el.parentElement.getAttribute('data-arrow-left-image');
      this.arrow_left_image_alt = this.$el.parentElement.getAttribute('data-arrow-left-image-alt');
      this.arrow_left_image_width = this.$el.parentElement.getAttribute('data-arrow-left-image-width');
      this.arrow_left_image_height = this.$el.parentElement.getAttribute('data-arrow-left-image-height');
      this.arrow_left_image_disabled = this.$el.parentElement.getAttribute('data-arrow-left-image-disabled');
      this.arrow_left_image_disabled_alt = this.$el.parentElement.getAttribute('data-arrow-left-image-disabled-alt');
      this.arrow_left_image_disabled_width = this.$el.parentElement.getAttribute('data-arrow-left-image-disabled-width');
      this.arrow_left_image_disabled_height = this.$el.parentElement.getAttribute('data-arrow-left-image-disabled-height');

      this.showCrosssellPercentage = this.$el.parentElement.getAttribute('data-show-crosssell-percentage') || 'false';

      this.isTab = this.$el.parentElement.getAttribute('data-is-tab') === 'true';
      this.isDefaultTab = this.$el.parentElement.getAttribute('data-is-default-tab') === 'true';

      if (this.isTab) {
        let tabsHolder = this.$el.parentElement;
        while (tabsHolder && !tabsHolder.hasAttribute('data-tabs-holder')) {
          tabsHolder = tabsHolder.parentElement;
        }

        if (tabsHolder) {
          const tabLinks = tabsHolder.querySelectorAll('.js-tab-link');
          tabLinks.forEach(link => {
            link.addEventListener('click', this.handleTabClick);
          });
        }
      }

      this.getClientWidth();

      if (!this.isTab || this.isDefaultTab) {
        this.loadCollectionData();
      }

      emitter.on('fs-products-loaded', e => {
        this.hasLoadedProducts = e;
        if (e) {
          this.$nextTick(() => {
            this.refreshCarouselHeight();
            this.syncArrowState();
          });
        }
      });

      document.addEventListener('theme:resize:width', this.syncArrowState);

      emitter.on('product-slide-loaded', index => {
        this.loadedSlides.add(index);
        if (!this.hasLoadedProducts) return;
        clearTimeout(this.carouselHeightRefreshTimeout);
        this.carouselHeightRefreshTimeout = setTimeout(() => {
          this.refreshCarouselHeight();
        }, 50);
      });
    },
    created() {
      window.addEventListener('resize', this.getClientWidth);
    },
    unmounted() {
      if (this.handleViewportSize) this.handleViewportSize();
      if (this.isTab) {
        let tabsHolder = this.$el.parentElement;
        while (tabsHolder && !tabsHolder.hasAttribute('data-tabs-holder')) {
          tabsHolder = tabsHolder.parentElement;
        }

        if (tabsHolder) {
          const tabLinks = tabsHolder.querySelectorAll('.js-tab-link');
          tabLinks.forEach(link => {
            link.removeEventListener('click', this.handleTabClick);
          });
        }
      }

      emitter.off('fs-products-loaded');
      emitter.off('product-slide-loaded');
      clearTimeout(this.carouselHeightRefreshTimeout);
      document.removeEventListener('theme:resize:width', this.syncArrowState);
      window.removeEventListener('resize', this.getClientWidth);
      this.loadedCollections.clear();
    },
    methods: {
      async loadCollectionData() {
        try {
          if (this.loadedCollections.has(this.collectionHandle)) {
            this.currentSlide = 0;
            this.productsOnDisplay = this.loadedCollections.get(this.collectionHandle);
            return;
          }

          this.productsOnDisplay = [];

          if (this.useFsWidgetRecs && this.widgetId) {
            await this.getWidgetProductRecs();
          } else if (this.useFsRecs) {
            await this.getProductRecs();
          } else if (this.useFsSmartCollection) {
            await this.getSmartCollectionProductData();
          } else {
            await this.getShopifyCollectionProducts();
          }

          if (this.productsOnDisplay.length > 0) {
            this.loadedCollections.set(this.collectionHandle, this.productsOnDisplay);
          }
        } catch (error) {
          logFastSimonError('Error loading collection data', error);
          this.productsOnDisplay = [];
        } finally {
          this.$nextTick(this.syncArrowState);
        }
      },

      getSmartCollectionProductData() {
        return new Promise((resolve, reject) => {
          try {
            whenFastSimonReady(() => {
              window.FastSimonSDK.smartCollections({
                categoryID: this.collectionId,
                productsPerPage: this.maxProducts,
                withAttributes: true,
                callback: response => {
                  const prods = response.payload.products;
                  const dataModified = [];
                  if (prods.length > 0) {
                    dataModified.push(...prods.filter(item => dataModified.length < this.maxProducts && !item.promotile));
                  }
                  this.productsOnDisplay = dataModified;
                  resolve();
                }
              });
            });
          } catch (error) {
            reject(error);
          }
        });
      },

      getWidgetProductRecs() {
        return new Promise((resolve, reject) => {
          try {
            const Pid = this.pids.sort(() => Math.random() - 0.5);
            this.recPid = Pid[0];
            whenFastSimonReady(() => {
              window.FastSimonSDK.productRecommendationByWidget({
                productID: this.recPid,
                withAttributes: true,
                widgetsIDS: [this.widgetId],
                callback: response => {
                  const productRecs = response.payload?.[0]?.payload || [];
                  this.productsOnDisplay = productRecs.slice(0, this.maxProducts);
                  resolve();
                }
              });
            });
          } catch (error) {
            reject(error);
          }
        });
      },

      getProductRecs() {
        return new Promise((resolve, reject) => {
          try {
            const Pid = this.pids.sort(() => Math.random() - 0.5);
            this.recPid = Pid[0];
            whenFastSimonReady(() => {
              window.FastSimonSDK.productRecommendation({
                productID: this.recPid,
                withAttributes: true,
                specs: [
                  {
                    sources: [window.fastSimonRecSource.toString()],
                    maxSuggestions: this.maxProducts,
                    widgetID: window.fastSimonRecId,
                    collectionIDs: [this.collectionId]
                  }
                ],
                callback: response => {
                  const productRecs = response.payload[0].payload;
                  this.productsOnDisplay = productRecs;
                  resolve();
                }
              });
            });
          } catch (error) {
            reject(error);
          }
        });
      },

      async getShopifyCollectionProducts() {
        try {
          const sliderElement = this.$el.parentElement;

          const url = `/collections/${this.collectionHandle}/products.json?limit=${this.maxProducts}`;
          const response = await fetch(url);
          const data = await response.json();

          let productMetafields = [];
          if (sliderElement?.dataset?.productMetafields) {
            try {
              const metafieldsString = sliderElement.dataset.productMetafields.replace(/&quot;/g, '"');
              productMetafields = JSON.parse(metafieldsString);
            } catch (jsonError) {
              logFastSimonError('Error parsing product metafields', jsonError);
            }
          }

          this.productsOnDisplay = data.products.map(product => {
            const productObj = {
              id: product.id.toString(),
              l: product.title
            };

            const productMeta = productMetafields.find(meta => meta.id.toString() === product.id.toString());

            const att = [
              ['Tag', product.tags || []],
              ['Type', [product.product_type || '']],
              ['Vendor', [product.vendor || '']]
            ];

            if (productMeta) {
              if (productMeta.gender) {
                att.push(['Custom.gender', [productMeta.gender]]);
                att.push(['custom.gender', [productMeta.gender]]);
              }

              if (productMeta.product_label) {
                att.push(['Custom.product_label', [productMeta.product_label]]);
                att.push(['custom.product_label', [productMeta.product_label]]);
              }

              const gender = productMeta.gender?.toLowerCase();
              if (gender) {
                if (gender === 'men') {
                  att.push(['Custom.category', ['Mens']]);
                  att.push(['custom.category', ['Mens']]);
                } else if (gender === 'women') {
                  att.push(['Custom.category', ['Womens']]);
                  att.push(['custom.category', ['Womens']]);
                } else if (gender === 'unisex') {
                  att.push(['Custom.category', ['Unisex']]);
                  att.push(['custom.category', ['Unisex']]);
                }
              }
            }

            productObj.att = att;
            return productObj;
          });
        } catch (error) {
          logFastSimonError('Error in getShopifyCollectionProducts', error);
          this.productsOnDisplay = [];
          return this.productsOnDisplay;
        }
      },

      getClientWidth() {
        const width = window.innerWidth;
        if (width <= window.theme.sizes.medium) {
          this.itemsToShow = Number(this.gridMobile);
          this.itemsToScroll = Number(this.gridDesktop);
        } else if (width > window.theme.sizes.medium && width <= window.theme.sizes.large) {
          this.itemsToShow = Number(this.gridTablet);
          this.itemsToScroll = Number(this.gridTablet);
        } else if (width > window.theme.sizes.large) {
          this.itemsToShow = Number(this.gridDesktop);
          this.itemsToScroll = Number(this.gridDesktop);
        }
      },
      syncArrowState() {
        const carousel = this.$refs.colSliderCarousel;
        if (!carousel) return;
        const { currentSlide, minSlide, maxSlide, slidesCount } = carousel.data;
        const disablePrev = currentSlide <= minSlide;
        // maxSlide is slidesCount - 1, so it alone would keep next active while the track
        // scrolls into empty slots; the remaining-items check is what finds the real end.
        const disableNext = currentSlide >= maxSlide || slidesCount - currentSlide <= this.itemsToShow;
        if (this.slidePrevBtn) this.slidePrevBtn.disabled = disablePrev;
        if (this.slideNextBtn) this.slideNextBtn.disabled = disableNext;
        if (this.slidePrevBtnCustom) this.slidePrevBtnCustom.disabled = disablePrev;
        if (this.slideNextBtnCustom) this.slideNextBtnCustom.disabled = disableNext;

        // Sections that render their own arrows outside this island cannot reach the emitter,
        // so the state travels as a bubbling DOM event instead. Counted from this slider's own
        // products, not hasLoadedProducts: that flag follows the page-global fs-products-loaded
        // emit, so another slider finishing first would hide these arrows over an empty track.
        const productCount = this.productsOnDisplay.length;
        const hideArrows = productCount > 0 && productCount <= this.itemsToShow;
        const root = this.$el?.parentElement;
        if (root) root.dispatchEvent(new CustomEvent('theme:carousel:arrows', { bubbles: true, detail: { disablePrev, disableNext, hideArrows } }));
      },
      clickPrev() {
        this.slidePrevBtn.click();
      },
      clickNext() {
        this.slideNextBtn.click();
      },
      slidePrev() {
        const carousel = this.$refs.colSliderCarousel;
        if (!carousel) return;
        const currentSlide = carousel.data.currentSlide;

        if (currentSlide > 0) {
          carousel.prev();
        }

        this.syncArrowState();
      },
      slideNext() {
        const carousel = this.$refs.colSliderCarousel;
        if (!carousel) return;
        const currentSlide = carousel.data.currentSlide;
        const maxSlide = carousel.data.maxSlide;

        if (currentSlide < maxSlide) {
          carousel.next();
        }

        this.syncArrowState();
      },
      reportProductViewRecommendation(productID, index, pid, widgetId) {
        whenFastSimonReady(() => {
          window.FastSimonSDK.event({
            eventName: window.FastSimonEventName.RecommendationProductClicked,
            data: {
              productID: productID,
              position: index,
              sourceProductID: pid,
              widget_id: widgetId || ''
            }
          });
          window.setFindingMethod('Collection Slider Recommendation');
        });
      },
      handleTabClick(event) {
        const clickedTab = event.currentTarget;
        const tabIndex = clickedTab.getAttribute('data-tab');
        let currentElement = this.$el;
        let tabContent = null;

        while (currentElement && !currentElement.classList?.contains('tab-content')) {
          currentElement = currentElement.parentElement;
          if (!currentElement) break;
        }

        tabContent = currentElement;

        if (tabContent && tabContent.classList?.contains(`tab-content-${tabIndex}`)) {
          if (this.loadedCollections.has(this.collectionHandle)) {
            this.currentSlide = 0;
            this.productsOnDisplay = this.loadedCollections.get(this.collectionHandle);
            this.$nextTick(this.syncArrowState);
          } else {
            this.hasLoadedProducts = false;
            this.loadCollectionData();
          }
        }
      },
      localGetProductMetafieldOneFromFS(products, index, attr) {
        return getProductMetafieldFromFS(products, index, attr);
      },
      localGetProductMetafieldTwoFromFS(products, index, attr) {
        return getProductMetafieldFromFS(products, index, attr);
      },
      localGetProductCategoryMetafieldOneCollectionFromFS(productList, index, metafieldStr) {
        return getProductCollectionMetafieldFromFS(productList, index, metafieldStr);
      },
      localGetProductCategoryMetafieldTwoCollectionFromFS(productList, index, metafieldStr) {
        return getProductCollectionMetafieldFromFS(productList, index, metafieldStr);
      },
      localGetProductReminderEmbedFromFS(products, index, attr) {
        return getProductMetafieldFromFS(products, index, attr);
      },
      isSlideLoaded(index) {
        return this.loadedSlides.has(index);
      },
      refreshCarouselHeight() {
        const carousel = this.$refs.colSliderCarousel;
        if (carousel && typeof carousel.restartCarousel === 'function') {
          carousel.restartCarousel();
        }
      }
    },
    computed: {
      freescrollSlideWidth() {
        return `calc(100% / ${this.itemsToShow})`;
      }
    }
  };
</script>

<template>
  <div class="section-carousel__header" v-if="!hideHeader">
    <p v-html="titleHeading" class="gt-h2 section-carousel__heading"></p>
  </div>

  <div class="collection-slider-placeholder-root" :inert="hasLoadedProducts" :aria-hidden="hasLoadedProducts ? 'true' : undefined">
    <carousel
      :items-to-show="itemsToShow"
      :items-to-scroll="itemsToScroll"
      class="col-slider-carousel placeholder-carousel"
      snapAlign="start"
      :class="{
        'is-hidden': hasLoadedProducts
      }"
    >
      <slide v-for="index in Math.ceil(itemsToShow)" :key="'loading-' + index" class="loading-slide">
        <div class="product-grid-item loading-placeholder">
          <div class="product-image-placeholder"></div>
          <div class="product-title-placeholder"></div>
          <div class="product-price-placeholder"></div>
          <div class="product-metafield-placeholder"></div>
        </div>
      </slide>
    </carousel>
  </div>

  <carousel
    :items-to-show="itemsToShow"
    :items-to-scroll="itemsToScroll"
    @slide-end="syncArrowState"
    :transition="400"
    class="col-slider-carousel product-carousel"
    :class="{
      'is-visible': hasLoadedProducts
    }"
    :mouse-drag="true"
    :touch-drag="true"
    :snap-align="false"
    :wrap-around="false"
    ref="colSliderCarousel"
    v-model="currentSlide"
  >
    <template #addons>
      <Navigation />
    </template>
    <slide v-for="(product, index) in productsOnDisplay" :key="'product-' + product.id + '-' + index" :class="['product-slide', index === productsOnDisplay.length - 1 ? 'product-slide--last' : '']">
      <template v-if="product.l">
        <div class="product-grid-item loading-placeholder" v-show="!isSlideLoaded(index)">
          <div class="product-image-placeholder"></div>
          <div class="product-title-placeholder"></div>
          <div class="product-price-placeholder"></div>
          <div class="product-metafield-placeholder"></div>
        </div>
        <ProductListItem v-show="isSlideLoaded(index)" :fsData="product" :useFsProductData="useFsProductData" :productTitle="product.l" :pid="product.id" :productImageName="productImageName" :gridSmall="Number(gridMobile)" :gridLarge="Number(gridDesktop)" :key="'grid' + product + '-' + index" :slideIndex="index" :productCategoryMetafieldOne="localGetProductMetafieldOneFromFS(this.productsOnDisplay, index, this.productCategoryMetafieldOneAttr)" :productCategoryMetafieldTwo="localGetProductMetafieldTwoFromFS(this.productsOnDisplay, index, this.productCategoryMetafieldTwoAttr)" :productCategoryMetafieldOneCollection="localGetProductCategoryMetafieldOneCollectionFromFS(this.productsOnDisplay, index, this.productCategoryMetafieldOneCollectionAttr)" :productCategoryMetafieldTwoCollection="localGetProductCategoryMetafieldTwoCollectionFromFS(this.productsOnDisplay, index, this.productCategoryMetafieldTwoCollectionAttr)" :productReminderMetafieldEmbed="localGetProductReminderEmbedFromFS(this.productsOnDisplay, index, this.productReminderMetafieldEmbedAttr)" :setReminderLinkText="setReminderLinkText" :hideSwatches="true" :showSalePercentage="showCrosssellPercentage === 'true'" @click="useFsRecs ? reportProductViewRecommendation(product.id, index, recPid, widgetId || window.fastSimonRecId || '') : null"></ProductListItem>
      </template>
    </slide>
  </carousel>

  <div class="collection-slider-freescroll">
    <div class="freescroll-track" data-custom-scrollbar-items-free>
      <div v-for="(product, index) in productsOnDisplay" :key="'product-' + product.id + '-' + index + '-freescroll'" :pid="product.id + '-freescroll'" class="freescroll__slide" :style="{ width: freescrollSlideWidth }">
        <div class="product-grid-item loading-placeholder" v-show="!isSlideLoaded(index)">
          <div class="product-image-placeholder"></div>
          <div class="product-title-placeholder"></div>
          <div class="product-price-placeholder"></div>
          <div class="product-metafield-placeholder"></div>
        </div>
        <ProductListItem v-show="isSlideLoaded(index)" :fsData="product" :useFsProductData="useFsProductData" :productTitle="product.l" :pid="product.id" :productImageName="productImageName" :gridSmall="Number(gridMobile)" :gridLarge="Number(gridDesktop)" :key="'grid' + product + '-' + index" :slideIndex="index" :productCategoryMetafieldOne="localGetProductMetafieldOneFromFS(this.productsOnDisplay, index, this.productCategoryMetafieldOneAttr)" :productCategoryMetafieldTwo="localGetProductMetafieldTwoFromFS(this.productsOnDisplay, index, this.productCategoryMetafieldTwoAttr)" :productCategoryMetafieldOneCollection="localGetProductCategoryMetafieldOneCollectionFromFS(this.productsOnDisplay, index, this.productCategoryMetafieldOneCollectionAttr)" :productCategoryMetafieldTwoCollection="localGetProductCategoryMetafieldTwoCollectionFromFS(this.productsOnDisplay, index, this.productCategoryMetafieldTwoCollectionAttr)" :productReminderMetafieldEmbed="localGetProductReminderEmbedFromFS(this.productsOnDisplay, index, this.productReminderMetafieldEmbedAttr)" :setReminderLinkText="setReminderLinkText" :hideSwatches="true" :showSalePercentage="showCrosssellPercentage === 'true'" @click="useFsRecs ? reportProductViewRecommendation(product.id, index, recPid, widgetId || window.fastSimonRecId || '') : null"></ProductListItem>
      </div>
    </div>
  </div>

  <div class="col-slider-custom-btns">
    <!-- Default navigation -->
    <button @click="slidePrev" class="carousel__prev" :class="this.arrow_custom_on ? 'is-hidden' : ''" type="button" aria-label="Previous" disabled="disabled">
      <svg class="flickity-button-icon" viewBox="0 0 100 100">
        <title>Previous</title>
        <path
          d="M 10, 50
          L 60, 100
          L 75, 90
          L 35, 50
          L 75, 10
          L 60, 0
          Z"
          class="arrow"
        ></path>
      </svg>
    </button>
    <button @click="slideNext" class="carousel__next" :class="this.arrow_custom_on ? 'is-hidden' : ''" type="button" aria-label="Next">
      <svg class="flickity-button-icon" viewBox="0 0 100 100">
        <title>Next</title>
        <path
          d="M 10, 50
          L 60, 100
          L 75, 90
          L 35, 50
          L 75, 10
          L 60, 0
          Z"
          class="arrow"
          transform="translate(100, 100) rotate(180)"
        ></path>
      </svg>
    </button>
    <!-- Custom arrow navigation -->
    <button @click="clickPrev" class="tabs__arrow--custom custom__arrow--prev" aria-label="Previous" :class="this.arrow_custom_on ? '' : 'is-hidden'">
      <img class="enabled" :src="arrow_left_image" :alt="arrow_left_image_alt + ' Previous'" :width="arrow_left_image_width" :height="arrow_left_image_height" />
      <img class="disabled" :src="arrow_left_image_disabled" :alt="arrow_left_image_disabled_alt + ' Previous, Disabled'" :width="arrow_left_image_disabled_width" :height="arrow_left_image_disabled_height" />
    </button>
    <button @click="clickNext" class="tabs__arrow--custom custom__arrow--next" aria-label="Next" :class="this.arrow_custom_on ? '' : 'is-hidden'">
      <img class="enabled" :src="arrow_left_image" :alt="arrow_left_image_alt + ' Next'" :width="arrow_left_image_width" :height="arrow_left_image_height" />
      <img class="disabled" :src="arrow_left_image_disabled" :alt="arrow_left_image_disabled_alt + ' Next, Disabled'" :width="arrow_left_image_disabled_width" :height="arrow_left_image_disabled_height" />
    </button>
  </div>
</template>

<style lang="scss">
  @keyframes placeholderShimmer {
    0% {
      transform: translateX(-100%) rotate(32deg);
    }
    100% {
      transform: translateX(100%) rotate(8deg);
    }
  }

  .collection-product-slider {
    // .collection-product-slider .col-slider-carousel
    .col-slider-carousel {
      width: 100%;
      transition: opacity 0.3s ease;

      .is-mobile & {
        display: none;
      }

      // .collection-product-slider .col-slider-carousel.placeholder-carousel
      &.placeholder-carousel {
        opacity: 1;
        z-index: 2;
        position: relative;
        min-height: var(--vc-trk-height, auto);
        height: 100%;

        .is-mobile & {
          display: block;
        }

        // .collection-product-slider .col-slider-carousel.placeholder-carousel.is-hidden
        &.is-hidden {
          height: 0;
          opacity: 0;
          pointer-events: none;
        }
      }

      // .collection-product-slider .col-slider-carousel.product-carousel
      &.product-carousel {
        height: 0;
        opacity: 0;
        z-index: 1;
        visibility: visible !important;

        // .collection-product-slider .col-slider-carousel.product-carousel.is-visible
        &.is-visible {
          height: auto;
          opacity: 1;
        }
      }
    }

    &.is-mobile {
      .col-slider-carousel {
        display: none;
      }
    }
    &.is-tablet,
    &.is-desktop {
      .collection-slider-freescroll {
        display: none;
      }
    }

    // .collection-product-slider .carousel__slide
    .carousel__slide {
      width: 100%;
      opacity: 1 !important;
      visibility: visible !important;
      scroll-snap-stop: normal;
      align-items: flex-start;
      padding: 0 calc(var(--gutter) / 2) 0 0;

      .is-tablet &,
      .is-desktop & {
        padding: 0 var(--gutter) 0 0;
      }

      // .collection-product-slider .carousel__slide.product-slide--last
      &.product-slide--last {
        padding-right: 0;
      }

      // .collection-product-slider .carousel__slide.product-slide
      &.product-slide {
        padding: 0;
      }
    }

    // .collection-product-slider .loading-slide, .collection-product-slider .product-slide
    .loading-slide,
    .product-slide {
      width: 100%;
      opacity: 1 !important;
      visibility: visible !important;
      height: auto;
    }

    // .collection-product-slider .product-wrapper
    .product-wrapper {
      width: 100%;
      opacity: 1 !important;
      visibility: visible !important;
      aspect-ratio: var(--PRODUCT-GRID-ASPECT-RATIO-DECIMAL);
    }

    // .collection-product-slider .loading-placeholder
    .loading-placeholder {
      width: 100%;

      // .collection-product-slider .loading-placeholder .product-image-placeholder,
      // .collection-product-slider .loading-placeholder .product-title-placeholder,
      // .collection-product-slider .loading-placeholder .product-price-placeholder
      .product-image-placeholder,
      .product-title-placeholder,
      .product-price-placeholder,
      .product-metafield-placeholder {
        position: relative;
        background-color: var(--hairline, #f6f6f6);
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          inset: -30%;
          width: 200%;
          height: 200%;
          background: linear-gradient(to right, transparent 16%, var(--bg) 32%, transparent 48%);
          animation: placeholderShimmer 2.4s linear infinite;
          transform-origin: center;
          pointer-events: none;
          transform: translateX(-100%) rotate(32deg);
          z-index: 1;
        }
      }

      .product-image-placeholder {
        width: 100%;
        aspect-ratio: var(--PRODUCT-GRID-ASPECT-RATIO-DECIMAL);
        margin-bottom: 1rem;
      }

      .product-title-placeholder {
        height: 20px;
        width: 80%;
        margin-bottom: 0.5rem;
      }

      .product-price-placeholder {
        height: 14px;
        width: 40%;
      }

      .product-metafield-placeholder {
        height: 14px;
        width: 60%;
        margin-top: 0.5rem;
      }
    }

    // .collection-product-slider .carousel__track
    .carousel__track {
      margin: 0;
    }

    // .collection-product-slider .carousel__viewport
    .carousel__viewport {
      overflow: hidden;

      .is-mobile & {
        overflow: visible;
      }
    }

    // .collection-product-slider .col-slider-custom-btns
    .col-slider-custom-btns {
      position: absolute;
      top: 0;
      left: auto;
      right: 0;
      width: 112px;
      z-index: 2;
    }

    // .collection-product-slider .hide-me
    .hide-me {
      opacity: 0;
    }

    // .collection-product-slider .hide-me-false
    .hide-me-false {
      // .collection-product-slider .hide-me-false .carousel__pagination,
      // .collection-product-slider .hide-me-false .carousel__prev,
      // .collection-product-slider .hide-me-false .carousel__next
      .carousel__prev,
      .carousel__next {
        opacity: 1;
        // Re-enable pointer events on hover so users can use the arrows.
        pointer-events: auto;
      }

      .carousel__pagination {
        opacity: 1;
        // Pagination dots stay non-interactive (buttons are display:none),
        // so leave pointer-events disabled so clicks pass through to the
        // image link beneath.
      }
    }

    // .collection-product-slider .hide-me-true
    .hide-me-true {
      // .collection-product-slider .hide-me-true .carousel__pagination
      // .collection-product-slider .hide-me-true .carousel__prev,
      // .collection-product-slider .hide-me-true .carousel__next
      .carousel__pagination,
      .carousel__prev,
      .carousel__next {
        opacity: 0;
        // Invisible at rest; ensure they don't swallow clicks on the
        // underlying image link before hover reveals them.
        pointer-events: none;
      }
    }

    // Slider navigation
    // .collection-product-slider .carousel__pagination
    .carousel__pagination {
      // Pagination dots are visual-only here (buttons are display:none below);
      // disabling pointer-events prevents the pagination overlay from
      // swallowing clicks on the underlying product image link.
      pointer-events: none;
      left: 5px;
      right: 5px;
      transition: opacity 0.2s linear;
      display: flex;
      justify-content: center;
      line-height: 0;
      margin: 10px 0 0 !important;
      padding: 0;
      transform: none;
      top: 0;

      .is-tablet & {
        top: 3px;
        margin-top: 5px;
      }

      .is-mobile & {
        top: 0px;
        margin-top: 5px;
      }
    }

    .is-mobile & {
      .product-image-carousel .carousel__pagination,
      .product-grid-item__container:hover .product-image-carousel .carousel__pagination,
      .product-grid-item__container:focus-within .product-image-carousel .carousel__pagination,
      .product-grid-carousel-wrap:hover .product-image-carousel .carousel__pagination,
      .product-grid-carousel-wrap:active .product-image-carousel .carousel__pagination,
      .product-grid-item__content.show-pagination-dots .product-image-carousel .carousel__pagination {
        display: none !important;
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
      }
    }

    // .collection-product-slider .carousel__pagination-item
    .carousel__pagination-item {
      width: 20px;
      height: 1px;
      display: inline-block;
      border: 0;
      margin: 0 4px 0.25em 4px;
      padding: 0;
      cursor: pointer;
      padding: var(--vc-pgn-margin);
      background: transparent;
      flex-grow: unset;
      border-radius: 0;

      .is-tablet &,
      .is-desktop & {
        top: 0px;
        padding-top: 0;
      }

      // .collection-product-slider .carousel__pagination-item::before
      &::before {
        content: none;
      }

      // .collection-product-slider .carousel__pagination-item::after
      &::after {
        display: block;
        content: '';
        border-radius: var(--vc-pgn-border-radius);
        width: 20px;
        height: 1px;
        background-color: var(--vc-pgn-background-color);
      }
    }

    // .collection-product-slider .carousel__pagination-button
    .carousel__pagination-button {
      display: none;

      // .collection-product-slider .carousel__pagination-button.carousel__pagination-button--active::after
      &--active::after {
        width: 20px;
        height: 1px;
        background-color: var(--vc-pgn-active-color);
      }
    }

    // .collection-product-slider .carousel__prev, .collection-product-slider .carousel__next
    .carousel__prev,
    .carousel__next {
      position: absolute;
      top: auto;
      bottom: 100%;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      border: none;
      color: var(--text);
      transition: all 0.3s;
      background: white;
      border: 1px solid black;
      border-radius: 0;
      transform: none;

      .is-tablet & {
        --padding-top: calc(var(--PT) * 0.8);
        --padding-bottom: calc(var(--PB) * 0.8);
      }

      .is-mobile & {
        display: none;
      }

      // .collection-product-slider .carousel__prev svg, .collection-product-slider .carousel__next svg
      svg {
        position: absolute;
        left: 33%;
        top: 33%;
        width: 35%;
        height: 35%;
        fill: currentColor;
      }

      // .fs-collection-slider .carousel__slide img
      > img {
        object-position: center center;
        aspect-ratio: var(--PRODUCT-GRID-ASPECT-RATIO-DECIMAL);

        .is-mobile & {
          height: 100%;
          width: 100%;
          overflow: hidden;
          object-fit: cover;
        }
      }

      // .fs-collection-slider .carousel__slide .product-grid-item
      .product-grid-item {
        width: 100%;
        padding: 0 calc(var(--gutter) / 2);

        .is-mobile & {
          padding: 0;
        }
      }

      // .fs-collection-slider .carousel__slide .product-grid-item > div
      .product-grid-item > div {
        width: 100%;
      }

      // .fs-collection-slider .carousel__slide .product__grid__title
      .product__grid__title {
        margin-top: 0;
      }
    }

    // .collection-product-slider .carousel__next
    .carousel__next {
      // .collection-product-slider .carousel__next img
      img {
        transform: rotate(180deg);
      }
    }

    // .collection-product-slider .carousel__slide
    .carousel__slide {
      // .carousel__slide .product-grid-item__image
      .product-grid-item__image {
        aspect-ratio: var(--PRODUCT-GRID-ASPECT-RATIO-DECIMAL);
        background: var(--PRODUCT-GRID-BACKGROUND-COLOR);
        object-fit: var(--PRODUCT-GRID-OBJECT-FIT);
      }
    }

    // .collection-product-slider .carousel__prev,
    //.collection-product-slider .carousel__next
    .carousel__prev,
    .carousel__next {
      display: none;
    }

    // .collection-product-slider .product-grid-item .product-grid-item__container a
    .product-grid-item .product-grid-item__container a {
      display: block;
    }

    // .collection-product-slider .product-grid-item__image
    .product-grid-item__image {
      aspect-ratio: var(--PRODUCT-GRID-ASPECT-RATIO-DECIMAL);
      object-fit: var(--PRODUCT-GRID-OBJECT-FIT);
      background: var(--PRODUCT-GRID-BACKGROUND-COLOR);
    }

    // .collection-product-slider .product-grid-item__container
    .product-grid-item__container {
      aspect-ratio: var(--PRODUCT-GRID-ASPECT-RATIO-DECIMAL);
      object-fit: var(--PRODUCT-GRID-OBJECT-FIT);
    }
  }

  // .collection-product-slider .product-placeholder
  .product-placeholder {
    width: 100%;
    aspect-ratio: var(--PRODUCT-GRID-ASPECT-RATIO-DECIMAL);
    object-fit: var(--PRODUCT-GRID-OBJECT-FIT);
    background: var(--PRODUCT-GRID-BACKGROUND-COLOR);
  }

  .collection-slider-freescroll {
    width: 100%;
    max-width: var(--LAYOUT-WIDTH);
    margin: 0 auto;
    padding-right: 0;
    touch-action: pan-x;
    pointer-events: all;

    .is-tablet &,
    .is-desktop & {
      display: none;
    }

    // .collection-slider-freescroll .freescroll-track
    .freescroll-track {
      display: flex;
      flex-flow: row nowrap !important;
      margin: 0 var(--outer-offset);
      overflow: hidden;
      overflow-x: scroll;
      -ms-overflow-style: none;
      padding-right: 0;
      position: relative;
      scroll-behavior: smooth;
      scroll-padding: var(--outer);
      scroll-snap-type: x mandatory;
      scrollbar-color: var(--border) var(--bg-accent);
      width: calc(100% + var(--outer) * 2);
      margin-right: var(--outer);
      padding-left: var(--outer);
      padding-right: var(--outer);

      // .collection-slider-freescroll .freescroll-track .freescroll__slide
      .freescroll__slide {
        flex: 0 0 auto;
        scroll-snap-align: start;

        // .collection-slider-freescroll .freescroll-track .freescroll__slide:not(:last-child)
        &:not(:last-child) {
          padding: 0 calc(var(--gutter) / 2) 0 0;

          // .collection-slider-freescroll .freescroll-track .freescroll__slide:not(:last-child) .carousel__slide
          .carousel__slide {
            padding: 0 calc(var(--gutter) / 2) 0 0;
          }
        }

        // .collection-slider-freescroll .freescroll-track .freescroll__slide .carousel__slide
        .carousel__slide {
          padding: 0;
        }
      }

      .carousel__slide {
        overflow-x: scroll;
      }

      img {
        pointer-events: none;
      }

      .carousel__pagination {
        display: none !important;
      }
    }

    .product__grid__title {
      margin-top: 0;
    }

    .product-grid-item__container {
      aspect-ratio: var(--PRODUCT-GRID-ASPECT-RATIO-DECIMAL);
      object-fit: var(--PRODUCT-GRID-OBJECT-FIT);
    }
  }
</style>
